import { LazyLoadImage } from "react-lazy-load-image-component";
import Starratting from "../assests/images/star.svg";

const renderStarImages = (count) => {
  return Array.from({ length: count }, (_, index) => (
    <LazyLoadImage
      key={`star-${index}`}
      src={Starratting}
      alt="Star"
      className="w-4 h-4 mx-[2px]"
      effect="blur"
    />
  ));
};

export default renderStarImages;